import api from '../lib/api';

export interface KustomerConfig {
  apiKey: string;
  organizationName: string;
}

export interface KustomerIntegrationStatus {
  connected: boolean;
  lastSyncAt?: string;
  config?: {
    organizationName: string;
  };
}

export interface KustomerConversationMetrics {
  date: string;
  conversationCount: number;
  avgHandleTime: number;
  channel: string;
}

const kustomerService = {
  async connect(organizationId: string, config: KustomerConfig): Promise<{ success: boolean; message: string }> {
    const response = await api.post('/integrations/kustomer/connect', {
      organizationId,
      config,
    });
    return response.data;
  },

  async testConnection(organizationId: string): Promise<{ success: boolean; message: string }> {
    const response = await api.get(`/integrations/kustomer/${organizationId}/test`);
    return response.data;
  },

  async syncAgents(organizationId: string): Promise<{ success: boolean; message: string }> {
    const response = await api.post(`/integrations/kustomer/${organizationId}/sync-agents`);
    return response.data;
  },

  async fetchMetrics(
    organizationId: string,
    startDate: string,
    endDate: string
  ): Promise<{ success: boolean; message: string; data: KustomerConversationMetrics[] }> {
    const response = await api.post(`/integrations/kustomer/${organizationId}/fetch-metrics`, {
      startDate,
      endDate,
    });
    return response.data;
  },

  async getStatus(organizationId: string): Promise<KustomerIntegrationStatus> {
    const response = await api.get(`/integrations/kustomer/${organizationId}/status`);
    return response.data;
  },

  async disconnect(organizationId: string): Promise<{ success: boolean; message: string }> {
    const response = await api.post(`/integrations/kustomer/${organizationId}/disconnect`);
    return response.data;
  },
};

export default kustomerService;
